// extracted by mini-css-extract-plugin
export default {"userMenuMenuItem":"UserMenu_userMenuMenuItem__NpMvs","userMenuMenuItemRole":"UserMenu_userMenuMenuItemRole__ir0vS","userMenuPopover":"UserMenu_userMenuPopover__Y5fmB"};